import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { useMediaQuery } from 'react-responsive'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import ArrowLeft from 'assets/img/arrow_left.png'
import ArrowRight from 'assets/img/arrow_right.png'

import * as productTypes from 'constants/product-types'
import { TagPushCarousel } from 'analytics/carousel'

import StringFormat from 'utils/StringFormat'
import { withMobile } from 'utils/mobile'

import { flipProduct, setCarouselProducts } from 'store/actions/home'
import { addEditProduct, openModal } from 'store/actions/cart'

import {
    ChristmasProductCard,
    CultureProductCard,
    FeedProductCard,
    MealProductCard,
    DefaultProductCard
} from '../ProductCard/types'

import Dots from '../Dots'
import { bankNameSelector } from 'store/selectors/bank'
import { homeErrorSelector, homeLoadingSelector } from 'store/selectors/home'

const productsIndex = [0, 4, 8]
const prevSlide = (index) => {
    if (index === 0) {
        return 8
    }

    return index - 4
}

const nextSlide = (index) => {
    if (index === productsIndex.length) {
        return 0
    }

    return index + 4
}

const filterProductsToTag = (startIndex, list) => {
    return list
        .filter((product) => product !== null)
        .slice(startIndex, startIndex + 4)
        .map((product) => product.props)
}

const PrevArrow = ({
    className,
    style,
    onClick,
    onSlideChange,
    currentSlide
}) => (
    <img
        className={className}
        style={style}
        onClick={(e) => {
            onClick(e)
            onSlideChange(prevSlide(currentSlide))
        }}
        src={ArrowLeft}
        alt="Banner anterior"
    />
)

const NextArrow = ({
    className,
    style,
    onClick,
    onSlideChange,
    currentSlide
}) => (
    <img
        className={className}
        style={style}
        onClick={(e) => {
            onClick(e)
            onSlideChange(nextSlide(currentSlide))
        }}
        src={ArrowRight}
        alt="Banner seguinte"
    />
)

const ProductsSlider = (props) => {
    const isLessThanMobile = useMediaQuery({ maxWidth: 520 })
    const isTablet = useMediaQuery({ maxWidth: 1050 })
    const isSmallTablet = useMediaQuery({ maxWidth: 772 })

    const { products, cart, mobile } = props

    const handleAddProduct = (values, product) => {
        props.addEditProduct({
            id: +product.code,
            qnt: +values.quantity,
            value: values.value,
            total: +values.quantity * parseFloat(values.value),
            loading: false
        })
        TagPushCarousel.addToCart({
            name: StringFormat.simpleNameProducts(parseInt(product.code)).split(
                '-'
            )[1],
            code: product.code,
            value: parseFloat(values.value),
            quantity: parseInt(values.quantity)
        })
        props.openCartMenu()
    }

    const getQtdSlides = () => {
        if (isLessThanMobile) return 1
        if (mobile || isSmallTablet) return 2
        if (isTablet) return 3
        return 4
    }

    const onSlideInit = () => {
        productsList.length > 0 &&
            TagPushCarousel.viewItem(filterProductsToTag(0, productsList))
    }

    const afterSlideChange = (index) => {
        TagPushCarousel.viewItem(filterProductsToTag(index, productsList))
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: getQtdSlides(),
        slidesToScroll: getQtdSlides(),
        autoplay: true,
        autoplaySpeed: 10000,
        prevArrow: <PrevArrow onSlideChange={afterSlideChange} />,
        nextArrow: <NextArrow onSlideChange={afterSlideChange} />,
        appendDots: (dots) => <Dots dots={dots} />,
        onInit: () => onSlideInit()
    }

    const hasProductsFlipped = products.some((p) => p.flipped)

    const getAvailableProductsList = (products, cart) => {
        const productsMap = {
            [productTypes.FEED]: FeedProductCard,
            [productTypes.MEAL]: MealProductCard,
            [productTypes.CHRISTMAS]: ChristmasProductCard,
            [productTypes.CULTURE]: CultureProductCard,
            [productTypes.MOBILITY]: DefaultProductCard,
            [productTypes.MULTIBENEFITS]: DefaultProductCard,
            [productTypes.AWARDS]: DefaultProductCard,
            [productTypes.EXPENSES]: DefaultProductCard,
            [productTypes.FLEET]: DefaultProductCard,
            [productTypes.VELOE]: DefaultProductCard,
            [productTypes.VT]: DefaultProductCard,
            [productTypes.PAYMENTS]: DefaultProductCard
        }

        return products.map((product) => {
            if (+product.code === props.id) {
                return null
            }

            const cartProductInfo = cart.products.find((cartProduct) => {
                return +product.code === +cartProduct.id
            })

            const Product = productsMap[product.code]

            return (
                <Product
                    key={product.id}
                    name={product.name}
                    id={product.id}
                    promotion={product.promotionId}
                    base={props.bankName}
                    code={product.code}
                    cart={cartProductInfo}
                    flipped={product.flipped}
                    hidden={hasProductsFlipped && !product.flipped}
                    purchased={!!cartProductInfo}
                    minValue={product.minValue}
                    maxValue={product.maxValue}
                    onFlip={props.flipProduct.bind(null, product.code, product)}
                    onAdd={handleAddProduct}
                />
            )
        })
    }

    const productsList = getAvailableProductsList(products, cart)

    return <Slider {...settings}>{productsList}</Slider>
}

const mapStateToProps = (state) => ({
    loading: homeLoadingSelector(state),
    error: homeErrorSelector(state),
    bankName: bankNameSelector(state),
    cart: state.cart
})

const mapDispatchToProps = (dispatch) => ({
    setCarouselProducts: (products) => dispatch(setCarouselProducts(products)),
    flipProduct: (code) => {
        dispatch(flipProduct(code))
    },
    addEditProduct: (product) => dispatch(addEditProduct(product)),
    openCartMenu: () => dispatch(openModal())
})

export default withMobile(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductsSlider))
)
